    import { Fragment, useState, useEffect } from "react";
    import { useNavigate } from "react-router-dom";
    import Header from "../component/layout/header";
    import Footer from "../component/layout/footer";
    import "../assets/css/studentProfile.css"; // Your existing CSS
    import rimage from "../assets/images/art/profile_image.jpg"
    import Swal from "sweetalert2";
    
    import { createPortal } from "react-dom";


    import { FaStar } from "react-icons/fa";
    import { FaGift } from "react-icons/fa";

    import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
    import { FaWhatsappSquare } from "react-icons/fa";

    import { FaUserFriends } from "react-icons/fa";


    const StudentProfilePage = () => {
      const navigate = useNavigate();
      const [student, setStudent] = useState(null);
      const [category, setCategory] = useState("");
      const [tutors, setTutors] = useState([]);
      const [selectedTutor, setSelectedTutor] = useState("");
      const [active, setActive] = useState("sentRequests");
      const [sentRequests, setSentRequests] = useState([]);
      const [apiCities, setApiCities] = useState([]);
      const [payments, setPayments] = useState([]);
      const [canSwitchProfile, setCanSwitchProfile] = useState(false);

    const switchProfile = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await fetch(
    "https://kalakakshaaha.com/kks/api/v1/switch-profile"
,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );




    const data = await res.json();

    if (!data.success) {
      Swal.fire("No other profile found");
      return;
    }

    // Save new JWT
    localStorage.setItem("token", data.token);

    Swal.fire({
      icon: "success",
      title: "Profile switched",
      showConfirmButton: false,
      timer: 1200,
      didClose: () => {
        if (data.role === "student") {
          navigate("/student-profile");
        } else {
          navigate("/tutor-profile");
        }
      }
    });

  } catch (err) {
    Swal.fire("Switch failed");
  }
};
const [selectedRequest, setSelectedRequest] = useState(null);

const openDetails = (req) => {
  setSelectedRequest(req);
};

const closeDetails = () => {
  setSelectedRequest(null);
};
const checkSwitchProfile = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await fetch(
      "https://kalakakshaaha.com/kks/api/v1/switch-profile",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const data = await res.json();

    if (data.success) {
      setCanSwitchProfile(true);   // has other profile
    } else {
      setCanSwitchProfile(false);  // no other profile
    }
  } catch {
    setCanSwitchProfile(false);
  }
};

const statusLabels = {
  0: "Pending",    // waiting for admin or tutor
  1: "Accepted",   // fully accepted
  2: "Rejected",   // rejected
};
      const paymentStatusMap = {
  0: "Pending",
  1: "Success",
  2: "Pending",
  3: "Pending",
};

    
      const categories = ["Music", "Dance", "Painting", "Singing"];
    
      // ------------------ FETCH STUDENT PROFILE ------------------
      useEffect(() => {
        const fetchStudentProfile = async () => {
          const token = localStorage.getItem("token");
          //console.log(token)

          if (!token) {
            alert("Login required");
            navigate("/login");
            return;
          }
    
          try {
            const res = await fetch(
              "https://kalakakshaaha.com/kks/api/student/profile",
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            const data = await res.json();
            if (data.success){
              const studentData = data.profile;

        studentData.languages =
          typeof studentData.languages === "string"
            ? JSON.parse(studentData.languages)
            : studentData.languages;
                        setStudent(studentData);
                        checkSwitchProfile();



            }
              
            else navigate("/login");
          } catch (err) {
            //console.log("Error fetching profile:", err);
            navigate("/login");
          }
        };
    
        fetchStudentProfile();
    
        window.addEventListener("focus", fetchStudentProfile);
        return () => window.removeEventListener("focus", fetchStudentProfile);
      }, [navigate]);

useEffect(() => {
  const token = localStorage.getItem("token");
  if (!token || !student?.id) return;

  //console.log("🔍 Fetching payments for user:", student.id);

fetch(`https://kalakakshaaha.com/kks/api/v1/payments/user/${student.user_id}`)

    .then(res => res.text())
    .then(text => {
      //console.log("📄 Raw response text:", text);
      const data = JSON.parse(text);
      //console.log("🧾 Parsed JSON:", data);

      if (data.success) {
        setPayments(data.payments || []);
        //console.log("💰 Payments array:", data.payments);
      }
    })
    .catch(err => console.error("❌ Payments fetch error", err));
}, [student?.id]);





      
    const [apiCountries, setApiCountries] = useState([]);
    const [apiStates, setApiStates] = useState([]);
    const [points, setPoints] = useState(0);
    const [pointsLoading, setPointsLoading] = useState(true);
    const [demoLoading, setDemoLoading] = useState(false);
    const [demoUnlocked, setDemoUnlocked] = useState(false);
    //referrals data
    const [referralHistory, setReferralHistory] = useState([]);
    const [refLoading, setRefLoading] = useState(true);

  
    useEffect(() => {
      fetch("https://kalakakshaaha.com/kks/api/v1/countries")
        .then(res => res.json())
        .then(data => data.success && setApiCountries(data.countries));

      fetch("https://kalakakshaaha.com/kks/api/v1/states")
        .then(res => res.json())
        .then(data => data.success && setApiStates(data.states));

      fetch("https://kalakakshaaha.com/kks/api/v1/cities")
        .then(res => res.json())
        .then(data => data.success && setApiCities(data.cities));
    }, []);
    const getCountryName = (id) => {
      const c = apiCountries.find(x => Number(x.id) === Number(id));
      return c ? c.country_name : "";
    };

    const getStateName = (id) => {
      const s = apiStates.find(x => Number(x.id) === Number(id));
      return s ? s.state_name : "";
    };

    const getCityName = (id) => {
      const c = apiCities.find(x => Number(x.id) === Number(id));
      return c ? c.city_name : "";
    };

    //copy referal function
    const copyReferral = () => {
      navigator.clipboard.writeText(referralLink);

      Swal.fire({
        icon: "success",
        title: "Copied!",
        text: "Referral link copied to clipboard",
        showConfirmButton: false,
        timer: 2000,
        width: 350,
        heightAuto: false,
        scrollbarPadding: false

      });
    };
    const referralCode = student?.referral_code; // later from backend
    // console.log(referralCode)
    const referralLink = `https://kalakakshaaha.com/signup?ref=${referralCode}`;


    //get points 
    useEffect(() => {
      const fetchPoints = async () => {
        const token = localStorage.getItem("token");
        if (!token) return;

        try {
          const res = await fetch(
            "https://kalakakshaaha.com/kks/api/v1/student/points",
            {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          );

          const data = await res.json();

          if (data.success) {
            setPoints(data.points);
          }
        } catch (err) {
          console.error("Error fetching points:", err);
        } finally {
          setPointsLoading(false);
        }
      };

      fetchPoints();
    }, []);

    //referal api
    useEffect(() => {
      const fetchReferralHistory = async () => {
        const token = localStorage.getItem("token");
        if (!token) return;

        try {
          const res = await fetch(
            "https://kalakakshaaha.com/kks/api/v1/student/referral-history",
            {
              headers: { Authorization: `Bearer ${token}` }
            }
          );
          const data = await res.json();

          if (data.success) {
            setReferralHistory(data.referrals);
          }
        } catch (err) {
          console.error("Referral history error:", err);
        } finally {
          setRefLoading(false);
        }
      };

      fetchReferralHistory();
    }, []);




      // ------------------ LOAD SENT REQUESTS ------------------
      const loadSentRequests = async () => {
        const token = localStorage.getItem("token");
    const res = await fetch(
  "https://kalakakshaaha.com/kks/api/v1/request/sent",
  {
    headers: { Authorization: `Bearer ${token}` },
  }
);

        const data = await res.json();
        if (data.success) setSentRequests(data.requests);
      };



    
      useEffect(() => {
        loadSentRequests();
      }, []);
    const Skeleton = () => (
      <div className="container">
        <section className="fun-layout">
          <div className="row">

            {/* LEFT PROFILE SKELETON */}
            <div className="col-12 col-lg-4 mb-4">
              <div className="profile-sidebar profile-card skeleton-card">
                <div className="skeleton avatar"></div>
                <div className="skeleton line w-70"></div>
                <div className="skeleton line w-40"></div>
                <hr />
                <div className="skeleton line w-90"></div>
                <div className="skeleton line w-80"></div>
                <div className="skeleton line w-60"></div>
              </div>
            </div>

            {/* RIGHT CONTENT SKELETON */}
            <div className="col-12 col-lg-8">
              <div className="fun-card skeleton-card mb-3">
                <div className="skeleton line w-30"></div>
              </div>

              <div className="fun-card skeleton-card">
                <div className="skeleton line w-100"></div>
                <div className="skeleton line w-90"></div>
                <div className="skeleton line w-80"></div>
              </div>
            </div>

          </div>
        </section>
      </div>
    );

      // if (!student) return <h2 style={{color:"white"}}>Loading...</h2>;





    
      return (
        <Fragment>


          <Header />
    {!student ? (
        <Skeleton />   // ✅ only content skeleton
      ) :(
          <div className="container">
            <section className="fun-layout">
              <div className="row" style={{ alignItems: "flex-start" }}>
                {/* LEFT SIDE — PROFILE */}
                <div className="col-12 col-lg-4 mb-4 mb-lg-0">
                  <div className="profile-sidebar w-100 profile-card">
                    {canSwitchProfile && (
  <button
    className="switch-profile-btn"
    onClick={switchProfile}
  >
    Switch to Tutor
  </button>
)}
                    <div className="profile-image">
                      {/* <img
                        src={`https://kalakakshaaha.com/uploads/students/${student.student_profile_photo}`}
                        alt="Profile"
                      />rimage  */}
                      <img
      src={
        student.student_profile_photo
          ? `https://kalakakshaaha.com/uploads/students/${student.student_profile_photo}`
          : rimage
      }
      alt="Profile"
    />

                    </div>



    
                    <h2 className="profile-name">
                      <span className="name-text">{student.full_name}</span>
                                        {/* <span className="name-text">{student.profession_id}</span> */}

                      {/* <span className="name-text"></span> 
    <p className="profile-role">{student.profession_name}</p> */}
                   


                    </h2>
<div className="edit-profile-wrapper">
  <i
    className="fas fa-edit edit-icon"
    title="Edit Profile"
    onClick={() => navigate("/edit-student-profile")}
  ></i>
  <div className="edit-tooltip" onClick={() => navigate("/edit-student-profile")} >Edit Profile</div>
</div>

                
                    <hr />
    
                    <div className="profile-section student-profile-section">
                      <h4>CONTACT</h4>
                      <p>   <i className="fa-solid fa-envelope"></i>
                      <span>{student.email}</span></p>
                      <p><i className="fa-solid fa-phone"></i>
                      <span>{student.phone_code}</span>
                      <span>{student.phone}</span></p>
                    </div>
    
                    {/* ✅ ADDED: GENDER & DOB (NO LAYOUT CHANGE) */}
                    <div className="profile-section">
                      <h4>PERSONAL INFO</h4>
                      <p>    <i className="fa-solid fa-user"></i>
                      <span>{student.gender || "-"}</span></p>
                      <p>     
                        {/* <i className="fa-solid fa-cake-candles"></i> */}
                        <i className="fa-regular fa-calendar"></i>
                      <span>{student.date_of_birth || "-"}</span></p>
                    </div>
    
                    <div className="profile-section">
                      <h4>SPECIALIZATION</h4>
                      <p>{student.profession_details}</p>
                    </div>
                    {/* points */}
                    <div className="profile-section">
                        <h4>POINTS EARNED</h4>

                        {pointsLoading ? (
                          <p>Loading points...</p>
                        ) : (
                          // <p style={{ fontSize: "18px", fontWeight: "bold", color: "#2563eb" }}>
                          //   🎯 {points} Points
                          // </p>
                          <p  className="points_earned">
                            <FaStar style={{ marginRight: "6px", color: "#f96706ff" }} />
                          {points} Points

                          </p>
                        )}

                        {/* <small className="text-muted">
                          Earn 100 points for every successful referral
                        </small> */}
                    </div>

                  
                  {/* langauges */}
                    <div className="profile-section">
                      <h4>LANGUAGES</h4>
                      <div className="languages-wrap">
      {student.languages?.map(lang => (
        <span
          key={lang.id}
          style={{
            padding: "4px 8px",
            // marginRight: "6px",
            background: "#eee",
            borderRadius: "12px",
            color:"black",
            fontSize:"14px"
          }}
        >
          {lang.language_name}
        </span>
      ))}
    </div>

                    </div>
    
    
                    <div className="profile-section">
                      <h4>ADDRESS</h4>
                      <p>
                        {[
                          student.address_line1,
                          student.address_line2,
                          student.area,
                          student.location,
                        getCityName(student.city_id),
                        getStateName(student.state_id),
                        getCountryName(student.country_id),
                          student.pincode,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                    </div>
                  

                  </div>
                </div>
    
                {/* RIGHT SIDE — TABS */}
                <div className="col-12 col-lg-8 d-flex flex-column">
                  <div className="fun-card mb-3">
                    <div className="tabs d-flex justify-content-center gap-3">
                      <button
                        className={`tab ${active === "sentRequests" ? "active" : ""}`}
                        onClick={() => setActive("sentRequests")}
                      >
                        Requests   <i className="fa-solid fa-envelope-open-text tab-icon"></i>

                      </button>
                      <button
                        className={`tab ${active === "pay" ? "active" : ""}`}
                        onClick={() => setActive("pay")}
                      >
                        Payments   <i className="fa-solid fa-wallet tab-icon"></i>

                        {/* 💰 */}
                      </button>
                      <button
                        className={`tab ${active === "note" ? "active" : ""}`}
                        onClick={() => setActive("note")}
                      >
                        Notifications   <i className="fa-solid fa-bell tab-icon"></i>

                        {/* 🔔 */}
                      </button>
                    </div>
                  </div>
                  
    
      {/* REQUESTS */}
                  <div className="fun-card mb-4 bg-white student-main-card">

 
  {/* REQUESTS */}
  {active === "sentRequests" && (
    <>
      <h4 className="mb-3">Requests Sent</h4>
 
      {sentRequests.length === 0 ? (
        <p className="text-muted">No requests sent yet</p>
      ) : (
        <div className="request-table-wrapper">
        <div className="request-row request-header">
  <div>Tutor</div>
  <div>Date</div>
  <div>Status</div>
  <div>Action</div>
</div>

{sentRequests.map(req => (
  <div className="request-row" key={req.id}>
    <div>{req.tutor_name}</div>
    <div>{req.request_date}</div>
<div className={`status-text status-${req.status}`}>
  {req.status === 2
    ? "Rejected"
    : req.status === 1 && req.tutor_status == 1
      ? "Accepted"
      : req.status === 1 && req.tutor_status == 0
        ? "⏳ Waiting for Tutor"
        : "Pending"}
</div>

    <div>
      <button
        className="details-btn"
        onClick={() => openDetails(req)}
      >
        More Details
      </button>
    </div>
  </div>
))}


{selectedRequest &&
  createPortal(
    <div className="request-modal-overlay" onClick={closeDetails}>
      <div
        className="request-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="request-modal-header">
          <h5>Request Details</h5>
          <button onClick={closeDetails} className="modal-close-btn">✕</button>
        </div>

        <div className="request-modal-body">

          <div className="info-grid">
            <div>
              <span className="label">Tutor</span>
              <p>{selectedRequest.tutor_name}</p>
            </div>

            <div>
              <span className="label">Date</span>
              <p>{selectedRequest.request_date}</p>
            </div>

            <div>
              <span className="label">Status</span>
              <p className={`status-text status-${selectedRequest.status}`}>
                {statusLabels[selectedRequest.status]}
              </p>
            </div>
          </div>

          <div className="detail-section">
            <span className="section-title">Categories</span>
            <div className="tag-containerr">
              {selectedRequest.category_names?.split(",").map((c, i) => (
                <span key={i} className="tag">{c}</span>
              ))}
            </div>
          </div>

          <div className="detail-section">
            <span className="section-title">Sub Categories</span>
            <div className="tag-containerr">
              {selectedRequest.skill_names?.split(",").map((s, i) => (
                <span key={i} className="tag tag-skill">{s}</span>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>,
    document.body
  )}


        </div>
      )}
    </>
  )}
 
{active === "pay" && (
  <>
    <h4 className="mb-3">Payments</h4>

    {payments.length === 0 ? (
      <p className="text-muted">No payments found</p>
    ) : (
      <ul className="list">
      {payments.map((p, i) => {
  const statusText = paymentStatusMap[p.status] || "Unknown";

  return (
    <li key={i} className="d-flex justify-content-between">
      <span>
        <i className="fa-solid fa-wallet tab-icon"></i>
        {new Date(p.created_at).toLocaleDateString()} — {p.currency} {p.amount}
      </span>

      <span
        className={`badge ${
          p.status === 1 ? "bg-success" :
          p.status === 3 ? "bg-warning" :
          "bg-danger"
        }`}
      >
        {statusText}
      </span>
    </li>
  );
})}

      </ul>
    )}
  </>
)}

  {/* NOTIFICATIONS */}
  {active === "note" && (
    <>
      <h4 className="mb-3">Notifications</h4>
 

    </>
  )}
 
</div>
 


                  
                  <div className="card p-4 shadow mt-4">
                        <h4 className="mb-2" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <FaGift style={{ color: "#ff9800" }} />
                          Refer & Earn
                        </h4>
                        <p className="text-muted">
                          Invite your friends and earn rewards when they join Kalakakshaaha.
                          Earn 100 points for every successful Referral
                        </p>

                        <div className="referral-box">
                        <input
                          type="text"
                          className="referral-input"
                          value={referralLink}
                          readOnly
                        />

                        <button
                          className="copy-btn"
                          type="button"
                          onClick={copyReferral}
                        
                        >
                          Copy Link
                        </button>
                        </div>


      {/* Share Buttons */}
      {/* <div className="d-flex gap-3 mt-3">
        <a
          href={`https://wa.me/?text=Join%20Kalakakshaaha%20using%20my%20referral%20link:%20${encodeURIComponent(referralLink)}`}
          target="_blank"
          rel="noreferrer" 
              aria-label="Share via WhatsApp"
              style={{
          display: "flex",
          alignItems: "center",
          lineHeight: 0,
        }}

        >
    <FaWhatsappSquare size={45} color="#25D366" />

        </a>

        <a
          href={`mailto:?subject=Join Kalakakshaaha&body=Use my referral link: ${referralLink}`}
          style={{
          display: "flex",
          alignItems: "center",
          lineHeight: 0,
        }}
        >
              <FaEnvelope size={45} color="#1976d2" />

        </a>
      </div> */}

                  <div className="d-flex gap-3 mt-3">
                    <a
                      href={`https://wa.me/?text=Join%20Kalakakshaaha%20using%20my%20referral%20link:%20${encodeURIComponent(referralLink)}`}
                      target="_blank"
                      rel="noreferrer"
                    className="btn wa-button d-flex align-items-center gap-2"
                    
                      
                    >
                          <FaWhatsapp size={25} />

                      WhatsApp
                    </a>

                    <a
                      href={`mailto:?subject=Join Kalakakshaaha&body=Use my referral link: ${referralLink}`}
                      className="btn btn-primary d-flex align-items-center gap-2"
                    >
                          <FaEnvelope size={22} />

                      Email
                    </a>
                  </div>


                  </div>
                

                  {/* referal history */}
                  <div className="card p-4 shadow mt-4">
      <h4 className="mb-3 d-flex align-items-center gap-2">
      <FaUserFriends color="#28a745" />
      Referral History
    </h4>


      {refLoading ? (
        <p>Loading referral history...</p>
      ) : referralHistory.length === 0 ? (
        <p className="text-muted">No referrals yet</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Points</th>
                {/* <th>Status</th> */}
                {/* <th>Date</th> */}
              </tr>
            </thead>
            <tbody>
              {referralHistory.map((ref, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{ref.name}</td>
                  <td>{ref.email}</td>
                  <td>
                    <span className="badge bg-success">
                      +{ref.points}
                    </span>
                  </td>
                  {/* <td>
                    {ref.status === 1 ? (
                      <span className="badge bg-success">Verified</span>
                    ) : (
                      <span className="badge bg-warning text-dark">Pending</span>
                    )}
                  </td> */}
                  {/* <td>
                    {new Date(ref.created_at).toLocaleDateString()}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>


                  



                  
                </div>
              </div>
            </section>
          </div>)}
    
          <Footer />
        </Fragment>
      );
    };
    
    export default StudentProfilePage;